<div class="confirm-modal ig-modal show-places-count-modal info-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div class="title">Item count for {{account.account.userName}}</div>

    <mat-tab-group>
        <mat-tab label="Places">
            <!--            <ng-template matTabContent mat-tab-label>-->
            <!--                Content 1 - Loaded: {{showTime()}}-->
            <!--            </ng-template>-->

            <div>
                <ig-spinner *ngIf="loading"></ig-spinner>
                <div *ngIf="itemCount" class="info-body m-t-3 text-left">
                    <div>Total place count: {{itemCount.place.total}}</div>
                    <div style="color: green">Approved: {{itemCount.place.approved}}</div>
                    <div style="color: red">Unapproved: {{itemCount.place.unApproved}}</div>
                </div>
                <ig-button size="md" color="warn" class="m-t-2" [isAsync]="true" (trigger)="deletePlaces($event)">Remove
                    all places for this account
                </ig-button>
            </div>
        </mat-tab>

        <mat-tab label="Events">
            <div>
                <ig-spinner *ngIf="loading"></ig-spinner>
                <div *ngIf="eventCount" class="info-body m-t-3 text-left">
                    <div>Total event count: {{eventCount.approved + eventCount.unapproved}}</div>
                    <div style="color: green">Approved: {{eventCount.approved}}</div>
                    <div style="color: red">Unapproved: {{eventCount.unapproved}}</div>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Editor's Choice">
            <div>
                <ig-spinner *ngIf="loading"></ig-spinner>
                <div *ngIf="itemCount" class="info-body m-t-3 text-left">
                    <div>Event: {{itemCount.choice.eventChoice}}</div>
                    <div>Place: {{itemCount.choice.placeChoice}}</div>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Pinned Top">
            <div>
                <ig-spinner *ngIf="loading"></ig-spinner>
                <div *ngIf="itemCount" class="info-body m-t-3 text-left">
                    <div>Event: {{itemCount.pinned.event}}</div>
                    <div>Place: {{itemCount.pinned.place}}</div>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Itineraries">
            <div>
                <ig-spinner *ngIf="loading"></ig-spinner>
                <div *ngIf="itemCount" class="info-body m-t-3 text-left">
                    <div>Item in itineraries: {{itemCount.tour.tourItemCount}}</div>
                    <div style="color: green">Published itinerary count: {{itemCount.tour.active}}</div>
                    <div style="color: red">Inactive itinerary count: {{itemCount.tour.inActive}}</div>

                    <ig-list>
                        <div header>
                            <ig-list-column-header>
                                <ig-row>
                                    <ig-col [xs]="4">Title</ig-col>
                                    <ig-col [xs]="1">Status</ig-col>
                                    <ig-col [xs]="2">Share Count</ig-col>
                                    <ig-col [xs]="2">Download PDF Count</ig-col>
                                </ig-row>
                            </ig-list-column-header>
                        </div>
                        <div body style="max-height: 400px;overflow-y: auto">
                            <ig-list-item *ngFor="let detail of itemCount.tour.details">
                                <ig-row>
                                    <ig-col [xs]="4">{{detail.title}}</ig-col>
                                    <ig-col [xs]="1">{{detail.isActive?'Active':'Inactive'}}</ig-col>
                                    <ig-col [xs]="2">{{detail.shareCount}}</ig-col>
                                    <ig-col [xs]="1">{{detail.downloadPDFCount}}</ig-col>
                                </ig-row>
                            </ig-list-item>
                        </div>
                        <div body *ngIf="!itemCount.tour.details.length">
                            No Content
                        </div>
                    </ig-list>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Trip Planner">
            <div>
                <ig-spinner *ngIf="loading"></ig-spinner>
                <div *ngIf="itemCount" class="info-body m-t-3 text-left">
                    <div>Event tab click count: {{itemCount.accountAnalytics.tripPlanner.eventClickCount}}</div>
                    <div>Place tab click count: {{itemCount.accountAnalytics.tripPlanner.placeClickCount}}</div>
                    <div>Itinerary tab count: {{itemCount.accountAnalytics.tripPlanner.tourClickCount}}</div>
                    <div>Trip planner tab count: {{itemCount.accountAnalytics.tripPlanner.userTripClickCount}}</div>
                    <div>Share button click count: {{itemCount.accountAnalytics.tripPlanner.shareClickCount}}</div>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="PDF Export History">
            <div>
                <ig-spinner *ngIf="loading"></ig-spinner>
                <ig-list *ngIf="itemCount">
                    <div header>
                        <ig-list-column-header>
                            <ig-row>
                                <ig-col [xs]="2">Download Time</ig-col>
                                <ig-col [xs]="1">Feed Type</ig-col>
                                <ig-col [xs]="2">Download Type</ig-col>
                                <ig-col [xs]="1">Version</ig-col>
                                <ig-col [xs]="2">Category</ig-col>
                                <ig-col [xs]="2">Item Export Count</ig-col>
                            </ig-row>
                        </ig-list-column-header>
                    </div>
                    <div body style="max-height: 400px;overflow-y: auto">
                        <ig-list-item *ngFor="let history of itemCount.pdfHistory">
                            <ig-row>
                                <ig-col [xs]="2">{{history.exportTime}}</ig-col>
                                <ig-col [xs]="1">{{history.feedType}}</ig-col>
                                <ig-col [xs]="2">{{history.downloadType}}</ig-col>
                                <ig-col [xs]="1">{{history.version}}</ig-col>
                                <ig-col [xs]="2">{{history.category}}</ig-col>
                                <ig-col [xs]="2">{{history.itemExportCount}}</ig-col>
                            </ig-row>
                        </ig-list-item>
                    </div>
                    <div body *ngIf="!itemCount.pdfHistory.length">
                        No Content
                    </div>
                </ig-list>
            </div>
        </mat-tab>
    </mat-tab-group>

</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/show.places.count/show.places.count.modal.component.html